import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { onNotificationClosed, onNotificationTriggered } from '../actions/notification.actions';
import { NotificationToast } from '../interfaces/NotificationToast.interface';

export const adapter: EntityAdapter<NotificationToast> = createEntityAdapter<NotificationToast>();

export const { selectAll } = adapter.getSelectors();

const initialState = adapter.getInitialState();
export const notificationReducer = createReducer(
    initialState,
    on(onNotificationTriggered, (state, action) => {
        return adapter.addOne(action.payload, state);
    }),
    on(onNotificationClosed, (state, action) => {
        return adapter.removeOne(action.payload, state);
    }),
);
